export default class CompareHelper {
    public static areMailsSame(one: string, two: string): boolean {
        return one.trim().toLowerCase() === two.trim().toLowerCase();
    }
}
